module.exports = __webpack_public_path__ + "img/sitevitals-logo.510dea25.png";